import { defineComponent as n, createBlock as o, openBlock as r, unref as l, mergeProps as p, withCtx as m, createElementVNode as c } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const u = /* @__PURE__ */ n({
  name: "IconExpand",
  __name: "IconExpand",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(e) {
    const t = e;
    return (i, a) => (r(), o(l(s), p(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...a[0] || (a[0] = [
        c("path", { d: "M4 7.75A.75.75 0 0 1 3.25 7V4.5A1.25 1.25 0 0 1 4.5 3.25H7a.75.75 0 1 1 0 1.5H5.81l3.72 3.72a.75.75 0 1 1-1.06 1.06L4.75 5.81V7A.75.75 0 0 1 4 7.75m11.53 6.72a.75.75 0 1 0-1.06 1.06l3.72 3.72H17a.75.75 0 0 0 0 1.5h2.5a1.25 1.25 0 0 0 1.25-1.25V17a.75.75 0 0 0-1.5 0v1.19l-3.72-3.72m-1.06-4.94a.75.75 0 0 1 0-1.06l3.72-3.72H17a.75.75 0 0 1 0-1.5h2.5a1.25 1.25 0 0 1 1.25 1.25V7a.75.75 0 1 1-1.5 0V5.81l-3.72 3.72a.75.75 0 0 1-1.06 0m-4.94 6a.75.75 0 1 0-1.06-1.06l-3.72 3.72V17a.75.75 0 0 0-1.5 0v2.5a1.25 1.25 0 0 0 1.25 1.25H7a.75.75 0 0 0 0-1.5H5.81l3.72-3.72" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
